export default [
  {
    type: 'banner',
    formItems: [
      {
        label: "切换时间",
        name: "interval",
        type: "text",
        stamp: 'input',
        key: "params",
        help: '轮播图自动切换的间隔时间，单位：毫秒',
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image'
      }
    ]
  },
  {
    type: 'windows',
    formItems: [
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "布局",
        name: "class",
        type: "text",
        stamp: 'radio',
        key: "style",
        help: '图片比例建议一致',
        options: [
          { label: '独占一行', value: 'full' },
          { label: '堆积两列', value: 'half' },
          { label: '堆积三列', value: 'third' },
          { label: '堆积四列', value: 'quarter' },
        ],
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image',
      }
    ]
  },
  {
    type: 'task',
    formItems: [
      {
        label: "模块背景色",
        name: "bgColor",
        type: "color",
        stamp: 'gpickr',
        key: "style",
        help:'背景为渐变色，由左往右渐变'
      },
      {
        label: "字体颜色",
        name: "color",
        type: "color",
        stamp: 'input',
        key: "style"
      },
      {
        label: "功能标题",
        name: "taskTitle",
        type: "text",
        stamp: 'input',
        key: "style"
      },
      // {
      //   label: "任务组",
      //   key: "data",
      //   stamp: 'task',
      // },
    ]
  },
  {
    type: 'assets',
    formItems: [
      {
        label: "模块背景色",
        name: "bgColor",
        type: "color",
        stamp: 'gpickr',
        key: "style",
        help:'背景为渐变色，由左往右渐变'
      },
      {
        label: "字体颜色",
        name: "color",
        type: "color",
        stamp: 'input',
        key: "style"
      },
      {
        label: "资产背景色",
        name: "assetsBgColor",
        type: "color",
        stamp: 'input',
        key: "style"
      },
      {
        label: "资产入口",
        name: "checked",
        stamp: 'checkeds',
        key: "data",
        help:'最少2个菜单'
      },
      {
        label: "权益标题",
        name: "privilegeTitle",
        type: "text",
        stamp: 'input',
        key: "style"
      },
      {
        label: "累计红包标题",
        name: "grandTitle",
        type: "text",
        stamp: 'input',
        key: "style"
      },
      {
        label: "展示标题",
        name: "show",
        stamp: 'switch',
        open:'显示',
        close:'隐藏',
        key: "style"
      },
      {
        label: "权益管理",
        key: "params",
        stamp: 'privilege'
      },
    ]
  },
  {
    type: 'module',
    formItems: [
      {
        label: "模块背景色",
        name: "bgColor",
        type: "color",
        stamp: 'gpickr',
        key: "style",
        help:'背景为渐变色，由左往右渐变'
      },
      {
        label: "字体颜色",
        name: "color",
        type: "color",
        stamp: 'input',
        key: "style"
      },
      {
        label: "功能标题",
        name: "moduleTitle",
        type: "text",
        stamp: 'input',
        key: "style"
      },
      {
        label: "展示标题",
        name: "show",
        stamp: 'switch',
        open:'显示',
        close:'隐藏',
        key: "style"
      },
      {
        label: "模块管理",
        key: "data",
        stamp: 'privilege'
      },
    ]
  },
  {
    type: 'receive',
    formItems: [
      {
        label: "模块背景色",
        name: "bgColor",
        type: "color",
        stamp: 'gpickr',
        key: "style",
        help:'背景为渐变色，由左往右渐变'
      },
      {
        label: "字体颜色",
        name: "color",
        type: "color",
        stamp: 'input',
        key: "style"
      },
      {
        label: "功能标题",
        name: "receiveTitle",
        type: "text",
        stamp: 'input',
        key: "style"
      }
    ]
  },
  {
    type: 'share',
    formItems: [
      {
        label: "模块背景色",
        name: "bgColor",
        type: "color",
        stamp: 'gpickr',
        key: "style",
        help:'背景为渐变色，由左往右渐变'
      },
      {
        label: "字体颜色",
        name: "color",
        type: "color",
        stamp: 'input',
        key: "style"
      },
      {
        label: "功能标题",
        name: "shareTitle",
        type: "text",
        stamp: 'input',
        key: "style"
      }
    ]
  },
  {
    type: 'distribute',
    formItems: [
      {
        label: "模块背景色",
        name: "bgColor",
        type: "color",
        stamp: 'gpickr',
        key: "style",
        help:'背景为渐变色，由左往右渐变'
      },
      {
        label: "下次派发模块背景色",
        name: "nextbgColor",
        type: "color",
        stamp: 'gpickr',
        key: "style",
        help:'背景为渐变色，由左往右渐变'
      },
      {
        label: "字体颜色",
        name: "color",
        type: "color",
        stamp: 'input',
        key: "style"
      },
      {
        label: "功能标题",
        name: "distributeTitle",
        type: "text",
        stamp: 'input',
        key: "style"
      }
    ]
  },
]